import { ComponentProps } from 'react';

import { Button } from '@veneer/core';

import ThemeProviderWrapper from '@storefront/app/ThemeProviderWrapper';

interface SecondaryButtonProps extends ComponentProps<typeof Button> {
  children?: React.ReactNode;
}

function SecondaryButton({
  children,
  ...props
}: Readonly<SecondaryButtonProps>) {
  return (
    <ThemeProviderWrapper theme="secondaryTheme">
      <Button {...props}>{children}</Button>
    </ThemeProviderWrapper>
  );
}

export default SecondaryButton;
